import PropTypes from 'prop-types'
import { ForbiddenPage } from 'components/elements'
import List from 'containers/pages/aboutDplk/List'
import Form from 'containers/pages/aboutDplk/Form'

const AboutDplkPage = ({ location, match, currentUser }) => {
  if (location.pathname === '/about-dplk') {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-dplk-anda-read') > -1) {
      return <List location={location} />
    }
    return <ForbiddenPage />
  }
  if (location.pathname.includes('/edit') || location.pathname.includes('/add')) {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-dplk-anda-write') > -1) {
      return <Form match={match} location={location} />
    }
    return <ForbiddenPage />
  }
  return ''
}

AboutDplkPage.propTypes = {
  currentUser: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
}

export default AboutDplkPage
